import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class MappedCurrencyPairCalendarImpl extends CubiqTS.CurrencyPairCalendarImpl {
  public tenorToValueAndFixingDateMap: Map<CubiqTS.Tenor, CubiqTS.TenorToValueAndFixingDate> =
    new Map();
  public tenorToValueDateMap: Map<CubiqTS.Tenor, CubiqTS.TenorToValueDate> = new Map();
  public ndfHolidays: Array<CubiqTS.Holiday>;
}
